'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { adjustPathnameLocale, getUrlOrigin } from '@monoimin/utils/helpers';
import { IS_GOLDEN_VISA } from '@monoimin/constants';

export const StepMetaTags = ({ id, site }: { id: string; site?: MiniSlug }) => {
  const pathname = usePathname() || '/';
  const [url, setUrl] = useState<string | null>(null);

  // Client-only effect to construct URL
  useEffect(() => {
    const sitePrefix = site ? `${site}/` : '';
    const withLocale = adjustPathnameLocale(pathname.replace(sitePrefix, ''));

    let adjustedPathname: string;
    if (IS_GOLDEN_VISA && withLocale.endsWith('/')) {
      adjustedPathname = withLocale.replace(/.$/, '');
    } else if (IS_GOLDEN_VISA) {
      adjustedPathname = withLocale;
    } else if (withLocale.endsWith('/')) {
      adjustedPathname = withLocale;
    } else {
      adjustedPathname = withLocale + '/';
    }

    const origin = getUrlOrigin(undefined, site);
    setUrl(origin + adjustedPathname + `#${id}`);
  }, [pathname, site, id]);

  // Don't render until URL is constructed client-side
  if (!url) {
    return null;
  }

  return (
    <div className='hidden' itemProp='url' data-testid='sb-how-to-step-url'>
      {url}
    </div>
  );
};
